import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchCaseDecision, upsertCaseDecision, updateDownstreamAction,
} from '../api/decision';

export const useCaseDecision = (caseNumber, enabled = true) =>
  useQuery({
    queryKey: ['case-decision', caseNumber],
    queryFn: () => fetchCaseDecision(caseNumber),
    enabled: !!caseNumber && enabled,
    staleTime: 15_000,
  });

export const useUpsertDecision = (caseNumber) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => upsertCaseDecision(caseNumber, payload),
    onSuccess: (data) => qc.setQueryData(['case-decision', caseNumber], data),
  });
};

export const useUpdateAction = (caseNumber) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ actionId, ...payload }) => updateDownstreamAction(actionId, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['case-decision', caseNumber] }),
  });
};
